import Welcome from './Welcome/index';
import Module from './Module/index';
import Identify from './Identify/index';
import Assist from './Assist/index';
import Refer from './Refer/index';
import Resources from './Resources/index';
import Reference from './IARReference/index';
import Mental from './Mental/index';
import ContactForm from './ContactForm/index';
import CertificatePage from './CertificatePage/index';
import CaseStudies from './CaseStudies/index';
import CaseStudiesQuestions from './CaseStudies/CaseStudiesQuestions/index';
import ThankYou from './ThankYou';
import TrainingCompleted from './TrainingCompleted';
import PreQuestionnaire from './PreQuestionnaire';
import Sitemap from './Sitemap';

const containers = {
  Welcome,
  Module,
  ...Identify,
  ...Assist,
  ...Refer,
  Resources,
  Reference,
  Mental,
  ContactForm,
  CertificatePage,
  CaseStudies,
  CaseStudiesQuestions,
  ThankYou,
  TrainingCompleted,
  PreQuestionnaire,
  Sitemap
};

export default containers;



// WEBPACK FOOTER //
// ./src/containers/index.jsx